module.exports = __webpack_public_path__ + "static/media/Intermediate.396bba71.svg";